import { lazy } from "react";
import Loadable from "components/Loadable";

// Lazy-loaded components
const Create = Loadable(lazy(() => import("../Create")));
const MaterialAndInspection = Loadable(lazy(() => import("../MaterialAndInspection")));

// Export only the child routes
const productDescriptionRoute = [
  {
    // path: routeConstants.PRODUCT_DESCRIPTION,
    path: "product-description",
    children: [
      {
        path: "add",
        element: <Create />
      },
      {
        path: "inspection",
        element: <MaterialAndInspection />
      }
    ]
  }
];

export default productDescriptionRoute;
